<template>
  <div class="qingxu_test">
    <h2 style="font-size: 24px; color: rgb(38, 38, 38); font-weight: bold; margin-bottom: 24px;">情绪状态测评</h2>
    <div class="qingxu_box">
      <div class="qingxu_tu">
        <img src="@/assets/shouhuan_icon.png" alt="">
      </div>
      <span style="display: block; text-align: center; font-size: 16px; font-weight: bold; margin: 16px 0px;">情绪状态测评团体数据</span>
      <div class="qingxu_btn">
        <a-button type="primary" @click="lookHandle">点击查看</a-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QingXuTest',
  methods: {
    lookHandle () {
      window.open('http://demo.lingximind.com/#/report?token=eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJqd3QiLCJpYXQiOjE2MTgzMDUzOTcsInN1YiI6IntcImNvbXBhbnlJZFwiOjI2NixcInJvbGVJZFwiOjIxMyxcInR5cGVcIjpcIkNcIixcInN0YWZmSWRcIjoyOTMsXCJ1c2VybmFtZVwiOlwibHZsdW9kZW1vXCJ9In0.iPIfR84Kwx0FdGnd0JoKY_BXPAuZBS8cs4x4fl47CYo')
    }
  }
}
</script>

<style>
.qingxu_test {
  width: 100%;
}
.qingxu_test .qingxu_box {
  width: 100%;
  padding: 40px 0px;
  background-color: #FFFFFF;
  border: 1px solid #E8E8E8;
}
.qingxu_test .qingxu_box .qingxu_tu {
  text-align: center;
}
.qingxu_test .qingxu_box .qingxu_tu img {
  width: 64px;
  height: auto;
}
.qingxu_test .qingxu_box .qingxu_btn {
  text-align: center;
}
.qingxu_test .ant-btn-primary {
  color: #FFFFFF;
  background-color: #51BF94;
  border-color: #51BF94;
}
.qingxu_test .ant-btn-primary:hover {
  color: #FFFFFF;
  background-color: rgba(81, 191, 148, .6);
  border-color: rgba(81, 191, 148, .6);
}
</style>
